/**
 * How many tags fit in `containerWidthPx` when hidden ones are replaced by an overflow badge.
 * At least one tag stays visible; the view truncates it when even that one does not fit.
 */
export function resolveVisibleTagCount(
  tagWidthsPx: readonly number[],
  gapPx: number,
  overflowWidthPx: number,
  containerWidthPx: number
): number {
  if (tagWidthsPx.length === 0 || containerWidthPx <= 0) {
    return 0;
  }

  const totalWidthPx = tagWidthsPx.reduce((sum, widthPx, index) => sum + widthPx + (index > 0 ? gapPx : 0), 0);
  if (totalWidthPx <= containerWidthPx) {
    return tagWidthsPx.length;
  }

  let usedWidthPx = 0;
  let visibleCount = 0;
  for (let index = 0; index < tagWidthsPx.length; index += 1) {
    const nextWidthPx = usedWidthPx + (index > 0 ? gapPx : 0) + tagWidthsPx[index];
    if (nextWidthPx + gapPx + overflowWidthPx > containerWidthPx) {
      break;
    }

    usedWidthPx = nextWidthPx;
    visibleCount = index + 1;
  }

  return Math.max(1, visibleCount);
}
